import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const ShowIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M10.07 5a18 18 0 0 0 6.69.72a.25.25 0 0 0 .24-.25V1a1 1 0 0 0-1.37-.93c-3.44 1.4-10.82 1.4-14.26 0A1 1 0 0 0 0 1v6.75c0 3.58 2.76 6.73 5.23 8.5a.28.28 0 0 0 .29 0a.27.27 0 0 0 .1-.27a9 9 0 0 1-.2-1.86v-6A3.38 3.38 0 0 1 10.07 5"
      />
      <path
        fill="currentColor"
        d="M23.17 6.58a1.9 1.9 0 0 0-1.76-.19c-2.84 1.15-9.07 1.15-11.9 0a1.9 1.9 0 0 0-1.76.19a1.87 1.87 0 0 0-.83 1.56v6c0 5.39 6.2 9.87 8.54 9.87S24 19.52 24 14.13v-6a1.87 1.87 0 0 0-.83-1.55M22 14.13c0 4.24-5.3 7.87-6.54 7.87s-6.54-3.63-6.54-7.87V8.66a.23.23 0 0 1 .1-.2a.24.24 0 0 1 .23 0a23.8 23.8 0 0 0 12.42 0a.24.24 0 0 1 .23 0a.26.26 0 0 1 .1.2Z"
      />
      <path
        fill="currentColor"
        d="M18.45 16.11a.74.74 0 0 0-1 .27a2.27 2.27 0 0 1-3.94 0a.75.75 0 0 0-1-.27a.74.74 0 0 0-.27 1a3.77 3.77 0 0 0 6.54 0a.75.75 0 0 0-.33-1m-.16-5.36a2.25 2.25 0 0 0-2.12 1.5a.75.75 0 1 0 1.41.5a.76.76 0 0 1 .71-.5a.75.75 0 0 1 .71.5a.75.75 0 0 0 .71.5a.7.7 0 0 0 .25 0a.76.76 0 0 0 .46-1a2.26 2.26 0 0 0-2.13-1.5m-4.96 2a.75.75 0 0 0 .71.5a.7.7 0 0 0 .25 0a.76.76 0 0 0 .46-1a2.26 2.26 0 0 0-4.25 0a.75.75 0 0 0 .46 1a.76.76 0 0 0 1-.46a.75.75 0 0 1 1.41 0Z"
      />
    </svg>
  );
};

export default ShowIcon;
